// @flow

type Props = {
  children: Function,
  isTestAbOption: boolean,
};

function TestAbSwitch({ children, isTestAbOption }: Props) {
  return children(isTestAbOption);
}

export default TestAbSwitch;



// WEBPACK FOOTER //
// ./app/TestAb/components/TestAbSwitch/index.js